import React from 'react'
import MobileSidebar from './mobileSidebar'
import DesktopSidebar from './desktopSidebar'

interface SideBarProps {
  isMobile: boolean;
  isSidebarOpen: boolean;
  onCloseSidebar: () => void;
}

const SideBar: React.FC<SideBarProps> = ({ isMobile, isSidebarOpen, onCloseSidebar }) => {
  // Return either the mobile or desktop sidebar based on screen size
  return isMobile ? (
    <MobileSidebar
      isSidebarOpen={isSidebarOpen}
      onCloseSidebar={onCloseSidebar}
    />
  ) : (
    <DesktopSidebar />
  )
}

export default SideBar
